import {createSelector} from 'reselect'

import shopsCache from 'services/cache/shops'

const cache = shopsCache.read() || {}

export const prefix = 'entities'
export const initialState = {
  shops: cache.entities || {}
}

export function createEntitiesSelector(type) {
  return (state) => {
    return state[prefix][type]
  }
}
export function createEntitySelector(entitiesSelector, idPropName = 'id') {
  return (idSelector) => {
    return createSelector(
      entitiesSelector,
      idSelector,
      (entities, id) => {
        const {
          [id]: {
            [idPropName]: entityID,
            pending,
            error,
            ...entity
          } = {}
        } = entities || {}

        return {
          ...entity,
          [idPropName]: entityID,
          pending,
          error,
          isExists: Object.keys(entity).length > 0
        }
      }
    )
  }
}

export const shopEntitiesSelector = createEntitiesSelector('shops')
export const createShopEntitySelector = createEntitySelector(shopEntitiesSelector, 'shop_id')
export const timeSeriesOptionsEntitiesSelector = createEntitiesSelector('time-series-options')
export const createTimeSeriesOptionsEntitySelector = createEntitySelector(timeSeriesOptionsEntitiesSelector)
export const timeSeriesDataEntitiesSelector = createEntitiesSelector('time-series-data')
export const createTimeSeriesDataEntitySelector = createEntitySelector(timeSeriesDataEntitiesSelector)



// WEBPACK FOOTER //
// ./src/services/store/entities/selectors.js